import React, { useState, useEffect } from 'react';
import { Redirect, Link } from 'react-router-dom';
import MenuHorizontal from "../../layouts/MenuHorizontal";
import MenuVertical from '../../layouts/MenuVertical';
import { Button, Icon, Loader, Pagination } from "semantic-ui-react";
import Responsavel from './Responsavel';
import api from '../../../api';

const Responsaveis = ({ match: { params } }) => {
  const [condominio, setCondominio] = useState({});
  const [responsaveis, setResponsaveis] = useState([]);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(true);
  const [busca, setBusca] = useState('');
  const [unidadesPorResp, setUnidadesPorResp] = useState({});
  const [registrosFiltrados, setRegistrosFiltrados] = useState([]);
  const [pagination, setPagination] = useState({
    dados: [],
    paginaAtual: 1,
    totalDePaginas: 0,
    registrosPorPagina: 18,
  });

  useEffect(
    () => {
      const init = async () => {
        try {
          const cond = await api.condominio.findSimpleById(params.id);
          setCondominio(cond);

          const resp = await api.responsavel.find(cond._id).then(res => res.responsaveis);
          setResponsaveis(resp);

          try {
            const unidades = await api.unidade.find(cond._id).then(res => res.unidades);
            const mapa = {};
            unidades.forEach(u => {
              const id = u.responsavel && (u.responsavel._id || u.responsavel);
              if (id) (mapa[id] = mapa[id] || []).push(u);
            });
            setUnidadesPorResp(mapa);
          } catch (e) {
            // sem as unidades o card apenas não mostra os vínculos
          }

          setRegistrosFiltrados(resp);
          updatePagination(resp);
          setLoading(false);
        } catch (e) {
          setErrors((e.data && e.data.errors) || {});
        }
      };

      init();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const containsInField = value => {
    const val = value.toLowerCase();
    const has = field => field && field.toLowerCase().indexOf(val) !== -1;
    return it => has(it.nome) || has(it.email) || has(it.documento) || has(it.celular);
  };

  const onChangeSearch = e => {
    setBusca(e.target.value);
    const dados = responsaveis.filter(containsInField(e.target.value));
    setRegistrosFiltrados(dados);
    updatePagination(dados);
  };

  const updatePagination = dados =>
    setPagination(p => ({
      ...p,
      paginaAtual: 1,
      dados: Array.from(Array(p.registrosPorPagina), (_, i) => dados[i]).filter(it => it !== undefined),
      totalDePaginas: Math.ceil(dados.length / p.registrosPorPagina),
    }));

  const changePage = (_, e) => {
    window.scrollTo(0, 0);
    setPagination(p => ({
      ...p,
      paginaAtual: e.activePage,
      dados: Array.from(
        Array(p.registrosPorPagina),
        (_, i) => registrosFiltrados[i + ((e.activePage - 1) * p.registrosPorPagina)])
          .filter(it => it !== undefined),
    }));
  };

  const getContent = () =>
    pagination.dados.length > 0 ? (
      <>
        <div className="va-prop-lista">
          {pagination.dados.map(responsavel => (
            <Responsavel
              key={responsavel._id}
              responsavel={responsavel}
              condominio={condominio}
              unidades={unidadesPorResp[responsavel._id] || []}
            />
          ))}
        </div>
        {pagination.totalDePaginas > 1 && (
          <div style={{ textAlign: 'center', marginTop: 30 }}>
            <Pagination activePage={pagination.paginaAtual} totalPages={pagination.totalDePaginas} onPageChange={changePage} />
          </div>
        )}
      </>
    ) : (
      <div className="empty-illustration-1">
        <img src="/images/illustrations/lupa-casa.svg" alt="Nenhum Responsável Encontrado" />
      </div>
    );

  return (
    <div>
      {!!errors.global && <Redirect to="/" />}
      <MenuHorizontal />
      <div className="corpo-dashboard">
        <MenuVertical condominio={condominio} />
        <header className="va-un-cabecalho">
          <h1>Proprietários</h1>
          <p>Responsáveis pelas unidades votantes. Os dados daqui são usados no envio do token e nos relatórios.</p>
        </header>
        {!loading && (
          <div className="va-un-barra-acoes">
            <Button className="btn-ui-1" as={Link} to={`/condominios/${condominio._id || params.id}/responsaveis/cadastrar`} size="large">
              <Icon name="plus" /> Cadastrar proprietário
            </Button>
          </div>
        )}
        <div className="va-un-filtros">
          <div className="va-un-busca">
            <Icon name="search" />
            <input
              type="search"
              placeholder="Buscar por nome, e-mail, documento ou celular"
              value={busca}
              onChange={onChangeSearch}
              aria-label="Buscar proprietário"
            />
          </div>
          <span className="va-contador">{registrosFiltrados.length} proprietário{registrosFiltrados.length !== 1 && 's'}</span>
        </div>
        {loading ? <Loader active inline='centered' style={{ marginTop: "50px" }} /> : getContent()}
      </div>
    </div>
  );
};

export default Responsaveis;
